import { useState, useEffect } from "react";
import { TransactionList } from "./TransactionList";
import { RegistrationGroup } from "../../api/getEventTransactionDetails/types";
import { Loader2 } from "lucide-react";

interface TransactionsViewProps {
  registrationGroups: RegistrationGroup[];
  isLoading: boolean;
  onRefundSuccess: () => void;
}

export function TransactionsView({
  registrationGroups,
  isLoading,
  onRefundSuccess,
}: TransactionsViewProps) {
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);

  // Update selected group when data refreshes to ensure we have latest data
  useEffect(() => {
    if (selectedGroupId) {
      // Check if the selected group still exists in the updated data
      const groupExists = registrationGroups.find(
        (g) => g.id === selectedGroupId,
      );
      if (!groupExists) {
        setSelectedGroupId(null);
      }
    }
  }, [registrationGroups, selectedGroupId]);

  const handleSelectGroup = (group: RegistrationGroup) => {
    // Toggle: if clicking the same group, collapse it
    if (selectedGroupId === group.id) {
      setSelectedGroupId(null);
    } else {
      setSelectedGroupId(group.id);
    }
  };

  const handleRefundSuccess = () => {
    onRefundSuccess();
    // Keep the row expanded so user can see updated state
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div>
      <TransactionList
        onRefundSuccess={handleRefundSuccess}
        onSelectGroup={handleSelectGroup}
        registrationGroups={registrationGroups}
        selectedGroupId={selectedGroupId}
      />
    </div>
  );
}
